export default __webpack_public_path__ + "static/media/owl.034476ab.jpeg";